import { IFetch } from 'lib/core/context/AuthProvider/Context';

import IQueue from 'lib/common/types/InstanceQueue';

import { TConfig } from '../types/Config';
import { LogEvents, logger } from '../components/LoggerController';

export default async function getInstanceQueues({
  fetch_,
  config,
}: {
  fetch_: IFetch;
  config: TConfig;
}): Promise<IQueue[]> {
  const apiEndpoint = `${config.QUEUES_SERVICE_URL}/user/queues?tenantId=${config.TENANT_ID}`;

  try {
    const allQueueResponse = await fetch_(apiEndpoint, {
      method: 'GET',
    });

    return (await allQueueResponse.json()).data as IQueue[];
  } catch (error) {
    logger.error(LogEvents.QUEUES_LOAD_FAILED, { apiEndpoint, error });
    return [];
  }
}
